import { createRoot } from 'react-dom/client';
import * as React from 'react';
import { UserProvider } from '../Context/UserContext';
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1,
            gcTime: 0,
        },
    },
});
const persister = createSyncStoragePersister({
    storage: window.localStorage,
});
export function createElement(root, element, props) {
    const ReactElement = () => React.createElement(element, props);
    const rootElement = createRoot(root);
    rootElement.render(<React.StrictMode>
        <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
            <UserProvider>
                <ReactElement />
            </UserProvider>
        </PersistQueryClientProvider>
    </React.StrictMode>);
}
